import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { ChevronDown, Cloud, Smartphone, Globe, Zap, Users, LineChart, Lightbulb } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

interface ServicesDropdownProps {
  textColor: string;
}

const ServicesDropdown: React.FC<ServicesDropdownProps> = ({ textColor }) => {
  const [isOpen, setIsOpen] = useState(false);

  const services = [
    {
      icon: <Smartphone className="w-5 h-5" />,
      title: "Applications Mobiles",
      description: "Apps natives et cross-platform pour iOS et Android",
      href: "/developpement-mobile"
    },
    {
      icon: <Globe className="w-5 h-5" />,
      title: "Applications Web",
      description: "Solutions web modernes et réactives",
      href: "/developpement-web"
    },
    {
      icon: <Cloud className="w-5 h-5" />,
      title: "Développement SaaS",
      description: "Solutions cloud évolutives et performantes",
      href: "/developpement-saas"
    },
    {
      icon: <Zap className="w-5 h-5" />,
      title: "Automatisation",
      description: "Optimisation des processus métier",
      href: "/ia-automatisation"
    },
    {
      icon: <Users className="w-5 h-5" />,
      title: "Marketplaces",
      description: "Plateformes de mise en relation",
      href: "/developpement-marketplace"
    },
    {
      icon: <LineChart className="w-5 h-5" />,
      title: "Maintenance & Support",
      description: "Support technique et monitoring",
      href: "/maintenance-support"
    },
    {
      icon: <Lightbulb className="w-5 h-5" />,
      title: "Prototype",
      description: "Testez votre idée avant d'investir",
      href: "/prototype"
    }
  ];

  return (
    <div className="relative" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <button
        className={cn(
          "inline-flex items-center gap-1 animated-link",
          textColor
        )}
      >
        <span className="text-sm font-medium">Nos services</span>
        <motion.span
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
          className="inline-flex items-center relative top-[4px]"
        >
          <ChevronDown className="w-4 h-4" />
        </motion.span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-[550px] bg-white rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 p-4"
          >
            <div className="flex flex-wrap justify-center gap-3">
              {services.map((service, index) => (
                <a
                  key={index}
                  href={service.href}
                  className="flex items-start p-3 rounded-lg hover:bg-slate-50 transition-colors duration-200 max-w-[230px]"
                >
                  <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-orcsys-50 flex items-center justify-center text-orcsys-500">
                    {service.icon}
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-slate-900">
                      {service.title}
                    </p>
                    <p className="text-xs text-slate-500 mt-0.5">
                      {service.description}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ServicesDropdown; 